<template>
    <main class="main">
        <router-view/>

        <div class="main__menu-button">
            <fab-button @click="openMenu">
                menu
            </fab-button>
        </div>

        <mainMenu/>

        <loading :show="loading"/>
    </main>
</template>

<script>
import MainMenu from '../menu/menu';
import Loading from '../loading/loading';
import FabButton from '../common/fab-button';
import { mapGetters } from 'vuex';

export default {
    components: {
        FabButton,
        MainMenu,
        Loading
    },
    computed: {
        ...mapGetters('user', [
            'loading'
        ])
    },
    methods: {
        openMenu() {
            this.$store.dispatch('menu/menuItems');
            this.$store.dispatch('menu/open', true);
        }
    }
}
</script>

<style scoped lang="scss">
    .main__menu-button {
        position: absolute;
        top: 1rem;
        left: 1rem;
        z-index: 99;

        @include medium {
            z-index: 9999;
        }

    }
</style>
